import PropTypes from 'prop-types';

import Field from 'zignal-landscape/lib/Field';
import Label from 'zignal-landscape/lib/Label';
import Select from 'zignal-landscape/lib/Select';
import Checkbox from 'zignal-landscape/lib/Checkbox';
import find from 'lodash/find';
import React from 'react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';


const TwitterImportsProfiles = ({profiles, selectedProfiles = {}, handleProfilesChange, campaigns = []}) => {
  const campaignId = get(profiles, '[0].campaign._id');
  const name = campaigns.find((e)=> e.value === campaignId) || '';
  const filteredProfiles = isEmpty(selectedProfiles[campaignId]) ? [] : selectedProfiles[campaignId];
  const allSelected = filteredProfiles.length === profiles.length && profiles.length > 0;
  return(
    <Field>
      <Label>{name.label}</Label>
      <Checkbox
        id={`checkboxField${campaignId}`}
        checked={allSelected}
        onChange={(value) => {
          const _isSelected = value.target.checked;
          handleProfilesChange({campaignId, profiles: _isSelected ? profiles : null});
        }
        }
      />Include All
      <Select
        id={`profilesField${campaignId}`}
        isMulti
        isClearable
        options={profiles.map((p) => ({value: p._id, label: p.name}))}
        value={filteredProfiles.map((p) => ({value: p._id, label: p.name}))}
        onChange={(options) =>
          handleProfilesChange({campaignId, profiles: options.map((o) => find(profiles, {_id: o.value}))})
        }
      />
    </Field>
  );
};

TwitterImportsProfiles.propTypes = {
  profiles: PropTypes.array,
  selectedProfiles: PropTypes.object,
  handleProfilesChange: PropTypes.func,
  campaigns: PropTypes.array,
};

export default TwitterImportsProfiles;
